module.exports = __webpack_public_path__ + "media/images/responsive/page_common/wave_bottom-999463b296b622056d819e703e4fa8c1.png";